import React from 'react';
import { Box, Typography } from '@mui/material';
import './OpenTicketCard.css';

const formatDuration = (value) => {
  if (!value || typeof value !== 'string') return '--';
  const parts = value.split(':');
  if (parts.length !== 3) return value;
  const [hoursRaw, minutesRaw, secondsRaw] = parts;
  const secondsPart = secondsRaw.split(/[.,]/)[0];
  const hours = hoursRaw.includes('.') ? hoursRaw : hoursRaw.padStart(2, '0');
  const minutes = minutesRaw.padStart(2, '0');
  const seconds = secondsPart.padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

const parseDurationToSeconds = (value) => {
  if (!value || typeof value !== 'string') return null;
  const parts = value.split(':');
  if (parts.length !== 3) return null;
  let [hoursRaw, minutesRaw, secondsRaw] = parts;
  let days = 0;
  if (hoursRaw.includes('.')) {
    const [daysStr, hoursStr] = hoursRaw.split('.');
    days = Number(daysStr);
    hoursRaw = hoursStr;
  }
  const secondsPart = secondsRaw.split(/[.,]/)[0];
  const hours = Number(hoursRaw);
  const minutes = Number(minutesRaw);
  const seconds = Number(secondsPart);
  if (
    !Number.isFinite(days) ||
    !Number.isFinite(hours) ||
    !Number.isFinite(minutes) ||
    !Number.isFinite(seconds)
  ) {
    return null;
  }
  return (days * 24 + hours) * 3600 + minutes * 60 + seconds;
};

const getStatus = (avgSeconds, slaSeconds) => {
  if (!Number.isFinite(avgSeconds) || !Number.isFinite(slaSeconds) || slaSeconds <= 0) {
    return null;
  }
  const ratio = avgSeconds / slaSeconds;
  if (ratio <= 0.75) return 'ok';
  if (ratio < 1) return 'warn';
  return 'alert';
};

const getPercent = (avgSeconds, slaSeconds) => {
  if (!Number.isFinite(avgSeconds) || !Number.isFinite(slaSeconds) || slaSeconds <= 0) {
    return null;
  }
  return Math.round((avgSeconds / slaSeconds) * 100);
};

const OpenTicketCard = ({ ticket, slaMetrics, stackMetrics = false }) => {
  const sequentialId = ticket?.sequentialId || '--';
  const clientName = ticket?.clientData?.nome_fantasia || '--';
  const customerName = ticket?.customerName || '--';
  const firstResponseRaw = ticket?.firstResponseTime;
  const attendanceRaw = ticket?.attendanceTime;
  const firstResponseTime = formatDuration(firstResponseRaw);
  const attendanceTime = formatDuration(attendanceRaw);
  const attendanceStatus = getStatus(
    parseDurationToSeconds(attendanceRaw),
    Number(slaMetrics?.attendance_time)
  );
  const firstResponseStatus = getStatus(
    parseDurationToSeconds(firstResponseRaw),
    Number(slaMetrics?.first_response_time)
  );
  const attendancePercent = getPercent(
    parseDurationToSeconds(attendanceRaw),
    Number(slaMetrics?.attendance_time)
  );
  const firstResponsePercent = getPercent(
    parseDurationToSeconds(firstResponseRaw),
    Number(slaMetrics?.first_response_time)
  );
  const attendancePercentLabel = Number.isFinite(attendancePercent) ? `${attendancePercent}%` : '--';
  const firstResponsePercentLabel = Number.isFinite(firstResponsePercent) ? `${firstResponsePercent}%` : '--';

  return (
    <Box className="openTicketCard">
      <Box className="openTicketCard__header">
        <Box className="openTicketCard__badge">#{sequentialId}</Box>
        <Typography className="openTicketCard__customerName" title={customerName}>
          {customerName}
        </Typography>
      </Box>
      <Box className="openTicketCard__body">
        <Typography className="openTicketCard__client" title={clientName}>
          {clientName}
        </Typography>
      </Box>
      <Box className={`openTicketCard__footer${stackMetrics ? ' openTicketCard__footer--stacked' : ''}`}>
        <Box
          className={`openTicketCard__metric${attendanceStatus ? ` openTicketCard__metric--${attendanceStatus}` : ''}`}
        >
          <span className="openTicketCard__metricLabel">Atendimento</span>
          <span className="openTicketCard__metricValue">
            {attendanceTime}
            <span className="openTicketCard__metricPercent">{attendancePercentLabel}</span>
          </span>
        </Box>
        <Box
          className={`openTicketCard__metric${firstResponseStatus ? ` openTicketCard__metric--${firstResponseStatus}` : ''}`}
        >
          <span className="openTicketCard__metricLabel">1ª resposta</span>
          <span className="openTicketCard__metricValue">
            {firstResponseTime}
            <span className="openTicketCard__metricPercent">{firstResponsePercentLabel}</span>
          </span>
        </Box>
      </Box>
    </Box>
  );
};

export default OpenTicketCard;
